import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function TestimonialsInitial() {
  return <section className="py-12 px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto" data-id="element-252">
      <div className="grid md:grid-cols-2 gap-6" data-id="element-253">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-navy-800/50 border border-navy-700 p-6 rounded-2xl backdrop-blur-sm" data-id="element-254">
          <div className="flex gap-1 mb-3" data-id="element-255">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold-400 text-gold-400" data-id="element-256" />)}
          </div>
          <p className="text-lg text-blue-50 italic mb-4" data-id="element-257">
            "La primera noche que usé el kit dormí 5 horas seguidas por primera
            vez en meses."
          </p>
          <p className="text-gold-400 font-medium" data-id="element-258">— Cecilia R., Mendoza</p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-navy-800/50 border border-navy-700 p-6 rounded-2xl backdrop-blur-sm" data-id="element-259">
          <div className="flex gap-1 mb-3" data-id="element-260">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold-400 text-gold-400" data-id="element-261" />)}
          </div>
          <p className="text-lg text-blue-50 italic mb-4" data-id="element-262">
            "Por fin alguien me explicó por qué mi bebé se despierta al ponerlo
            en la cuna. Cambió todo."
          </p>
          <p className="text-gold-400 font-medium" data-id="element-263">— Laura P., Rosario</p>
        </motion.div>
      </div>
    </section>;
}